import React from 'react';
import { Component } from 'react';
import { Site, Dimmer } from "tabler-react";

/**
 * Función que contiene el código para hacer el login
 * @author Joel Martinez <joel.martinez@mxmart.mx>
 * @version 1.0 09/07/2021
*/
class login extends Component {
	componentDidMount() {
		const proveedorIdentidad = process.env.REACT_APP_ENDPOINT ? process.env.REACT_APP_ENDPOINT !== "None" ? "SamlProdDocentes" : "OneloginSamlDocentes" : "OneloginSamlDocentes";
		const urlRetorno = window.location.origin + "/auth";
		const urlLogin = "https://onelogin-saml-ieu.auth.us-east-1.amazoncognito.com/oauth2/authorize?identity_provider=" + proveedorIdentidad + "&redirect_uri="+urlRetorno+"&response_type=code&client_id=3bl6u63nn4268k66hbtkh111p4"
		window.location.assign(urlLogin);
	}
	
	render() {
		return(
			<Site>
				<Dimmer loader active />
			</Site>
		)
	}
}

export default login;